<template>
  <div>
    <div v-if="this.loadingFormSubmit == true" class="loader">Loading...</div>

    <el-card v-if="this.loadingFormSubmit == false" class="cont-card form-card">
      <h1>Leave Property</h1>
      <h4>Are you sure you want to leave this property?</h4>
      <h5>This action cannot be undone.</h5>
      <el-button
        type="danger"
        text
        @click="
          dialog = false;
          leaveProperty(property.propertyid, property);
        "
      >Leave Property</el-button>
      <el-button text @click="cancelLeaveProperty()">Cancel</el-button>
    </el-card>
  </div>
</template>

<script>
import EventService from "@/services/EventService.js";
import { mapState, mapActions } from "vuex";
export default {
  props: {
    property: Object
  },
  data(){
    return{
      loadingFormSubmit: false
    }
  },
  computed: {
    ...mapState({
      user: state => state.user.user
    })
  },
  methods: {
    leaveProperty(propertyid, property) {
      
      this.loadingFormSubmit = true;

      EventService.UserLeaveProperty(this.property.propertyid, this.user.userid)
        .then(response => {
          if (response.status == 204) {

            this.$emit("delete-property-locally", property);

            this.$store.dispatch("addNotification", {
              type: "success",
              Message: "You have left the property"
            });

            this.$router.push("/DashboardAllProperties");
          }
        })
        .catch(error => {
            console.log(error);
            this.cancelLeaveProperty();
        });
    },
    cancelLeaveProperty() {
      this.$emit("close-leave-property-form");
    }
  }
};
</script>

<style>
</style>